import React from 'react'

interface AIIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const AIIcon: React.FC<AIIconProps> = ({
  color = '#000',
  gradient,
  width = 17,
  height = 19,
  alt = 'AI icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 17 19'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.09615 2.47753L4.21799 2.00374L4.33984 2.47753C4.54409 3.27177 5.1643 3.89197 5.95854 4.09622L6.43223 4.21804L5.95852 4.33986C5.16429 4.54412 4.54409 5.16432 4.33984 5.95855L4.21799 6.43234L4.09614 5.95855C3.89189 5.16432 3.27169 4.54412 2.47746 4.33986L2.00375 4.21804L2.47744 4.09622C3.27168 3.89197 3.89189 3.27177 4.09615 2.47753ZM3.24951 0.750931C3.507 -0.250311 4.92898 -0.25031 5.18648 0.750932L5.55044 2.16619C5.64123 2.51919 5.91687 2.79483 6.26987 2.88561L7.68504 3.24954C8.68629 3.50703 8.6863 4.92902 7.68506 5.18652L6.26986 5.55047C5.91687 5.64125 5.64123 5.91689 5.55045 6.26989L5.18648 7.68515C4.92898 8.68639 3.507 8.68639 3.24951 7.68515L2.88554 6.26989C2.79476 5.91689 2.51911 5.64125 2.16612 5.55047L0.75093 5.18652C-0.250314 4.92902 -0.250308 3.50703 0.750938 3.24954L2.16611 2.88561C2.51911 2.79483 2.79476 2.51919 2.88554 2.16619L3.24951 0.750931ZM9.61209 10.2963L10.1038 8.38422L10.5956 10.2963C10.7998 11.0906 11.42 11.7108 12.2143 11.915L14.1264 12.4067L12.2143 12.8985C11.42 13.1027 10.7998 13.7229 10.5956 14.5172L10.1038 16.4292L9.61209 14.5172C9.40784 13.7229 8.78764 13.1027 7.99341 12.8985L6.08131 12.4067L7.99341 11.915C8.78764 11.7108 9.40784 11.0906 9.61209 10.2963ZM9.13534 7.13139C9.39284 6.13014 10.8148 6.13014 11.0723 7.13138L11.8062 9.98498C11.897 10.338 12.1726 10.6136 12.5256 10.7044L15.3792 11.4383C16.3804 11.6958 16.3804 13.1177 15.3792 13.3752L12.5256 14.1091C12.1726 14.1999 11.897 14.4755 11.8062 14.8285L11.0723 17.682C10.8148 18.6833 9.39284 18.6833 9.13534 17.682L8.40148 14.8285C8.3107 14.4755 8.03507 14.1999 7.68207 14.1091L4.82849 13.3752C3.82725 13.1177 3.82725 11.6958 4.82849 11.4383L7.68207 10.7044C8.03507 10.6136 8.3107 10.338 8.40148 9.98498L9.13534 7.13139Z'
      />
    </svg>
  )
}

export default AIIcon
